var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientfinancial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1456,
    height: 1774,
    viewBox: "0 0 1456 1774",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1213.85 157.524C1002.37 5.64324 641.358 -33.6331 453.036 29.8644C113.408 144.461 58.9436 367.145 62.6188 566.228C66.2941 765.311 321.48 936.276 389.405 1110.3C457.331 1284.32 581.89 1518.25 822.464 1446.6C1063.04 1374.96 1052.72 1115.92 1125.6 941.014C1198.49 766.108 1389.11 586.774 1378.75 426.215C1371.54 314.098 1307.29 224.874 1213.85 157.524Z",
    fill: "#BA68C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1213.85 157.524C1002.37 5.64324 641.358 -33.6331 453.036 29.8644C113.408 144.461 58.9436 367.145 62.6188 566.228C66.2941 765.311 321.48 936.276 389.405 1110.3C457.331 1284.32 581.89 1518.25 822.464 1446.6C1063.04 1374.96 1052.72 1115.92 1125.6 941.014C1198.49 766.108 1389.11 586.774 1378.75 426.215C1371.54 314.098 1307.29 224.874 1213.85 157.524Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M637.242 306.792H55.5352C34.626 306.792 17.6758 323.742 17.6758 344.651V764.426C17.6758 785.335 34.626 802.285 55.5352 802.285H637.242C658.151 802.285 675.101 785.335 675.101 764.426V344.651C675.101 323.742 658.151 306.792 637.242 306.792Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M620.947 280.711H39.2403C18.3311 280.711 1.38086 297.661 1.38086 318.57V738.345C1.38086 759.254 18.3311 776.204 39.2403 776.204H620.947C641.856 776.204 658.806 759.254 658.806 738.345V318.57C658.806 297.661 641.856 280.711 620.947 280.711Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M213.925 507.336L73.3804 552.945C61.2675 515.646 64.464 475.064 82.2672 440.122C100.07 405.18 131.022 378.739 168.317 366.614C183.015 361.693 198.426 359.239 213.925 359.352V507.336Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.926 507.336L300.847 626.892C269.125 649.926 229.553 659.419 190.833 653.282C152.113 647.146 117.415 625.883 94.3696 594.169C85.145 581.681 78.0528 567.751 73.3809 552.944L213.926 507.336Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.926 507.336L354.559 461.639C364.575 491.288 364.767 523.376 355.108 553.143C345.449 582.911 326.452 608.772 300.936 626.892L213.926 507.336Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.926 507.336V359.441C245.241 359.085 275.836 368.836 301.17 387.246C326.504 405.657 345.227 431.745 354.559 461.639L213.926 507.336Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.146 599.439C265.062 599.439 306.337 558.163 306.337 507.248C306.337 456.332 265.062 415.057 214.146 415.057C163.23 415.057 121.955 456.332 121.955 507.248C121.955 558.163 163.23 599.439 214.146 599.439Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M606.024 350.407H403.443V367.189H606.024V350.407Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M562.453 386.318H403.443V403.101H562.453V386.318Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M520.298 422.229H403.443V439.012H520.298V422.229Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M569.493 458.141H403.443V474.923H569.493V458.141Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M482.35 494.052H403.443V510.834H482.35V494.052Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M606.024 530.007H403.443V546.789H606.024V530.007Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M552.623 565.918H403.443V582.7H552.623V565.918Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M533.804 601.829H403.443V618.611H533.804V601.829Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M606.024 637.74H403.443V654.522H606.024V637.74Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M138.738 686.67H295.755",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.51 708.81H317.984",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M408.846 686.67H565.863",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M386.617 708.81H588.091",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M640.473 1008.94H140.906C119.997 1008.94 103.047 1025.89 103.047 1046.8V1404.67C103.047 1425.58 119.997 1442.53 140.906 1442.53H640.473C661.382 1442.53 678.333 1425.58 678.333 1404.67V1046.8C678.333 1025.89 661.382 1008.94 640.473 1008.94Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M620.903 986.18H121.336C100.427 986.18 83.4766 1003.13 83.4766 1024.04V1381.91C83.4766 1402.82 100.427 1419.77 121.336 1419.77H620.903C641.812 1419.77 658.762 1402.82 658.762 1381.91V1024.04C658.762 1003.13 641.812 986.18 620.903 986.18Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.885 1192.3H199.622",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.885 1209.66H244.256",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.885 1226.97H199.622",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M122.885 1244.29H233.585",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122.885 1261.65H199.622",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.885 1278.96H258.47",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M315.061 1192.3H391.798",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M315.061 1209.66H436.432",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M315.061 1226.97H391.798",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M315.061 1244.29H425.761",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M315.061 1261.65H391.798",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M315.061 1278.96H450.646",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M507.236 1192.3H583.974",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M507.236 1209.66H628.564",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M507.236 1226.97H583.974",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M507.236 1244.29H617.892",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M507.236 1261.65H583.974",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M507.236 1278.96H642.822",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M266.486 1135.36H117.971V1165.07H266.486V1135.36Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M462.025 1135.36H313.51V1165.07H462.025V1135.36Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M657.566 1135.36H509.051V1165.07H657.566V1135.36Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M289.645 1133.63V1283.96",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M483.59 1133.63V1283.96",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M178.501 1064.95L210.648 1054.5C212.71 1060.86 212.842 1067.68 211.027 1074.11C209.212 1080.54 205.532 1086.29 200.451 1090.63C195.371 1094.96 189.118 1097.7 182.483 1098.48C175.849 1099.27 169.131 1098.07 163.178 1095.04C157.225 1092.01 152.305 1087.28 149.039 1081.45C145.773 1075.62 144.308 1068.95 144.83 1062.29C145.351 1055.63 147.836 1049.28 151.969 1044.03C156.102 1038.78 161.699 1034.88 168.051 1032.81C171.42 1031.69 174.951 1031.14 178.501 1031.17V1064.95Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 1064.95V1031.17C185.656 1031.08 192.649 1033.3 198.441 1037.51C204.232 1041.71 208.513 1047.67 210.647 1054.5L178.5 1064.95Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M503.96 1064.95L536.107 1054.5C538.172 1060.86 538.306 1067.69 536.492 1074.12C534.677 1080.55 530.996 1086.3 525.914 1090.64C520.831 1094.98 514.576 1097.71 507.939 1098.5C501.302 1099.28 494.582 1098.08 488.628 1095.04C482.674 1092.01 477.755 1087.27 474.491 1081.44C471.228 1075.61 469.768 1068.94 470.295 1062.28C470.822 1055.62 473.313 1049.26 477.453 1044.01C481.594 1038.77 487.197 1034.87 493.554 1032.81C496.908 1031.69 500.424 1031.14 503.96 1031.17V1064.95Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M503.959 1064.95V1031.17C511.117 1031.07 518.113 1033.29 523.906 1037.5C529.699 1041.7 533.978 1047.67 536.106 1054.5L503.959 1064.95Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M287.075 1064.95V1098.74C278.114 1098.74 269.521 1095.18 263.185 1088.84C256.849 1082.51 253.289 1073.91 253.289 1064.95C253.289 1055.99 256.849 1047.4 263.185 1041.06C269.521 1034.73 278.114 1031.17 287.075 1031.17V1064.95Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M287.076 1064.95V1031.17C296.037 1031.17 304.63 1034.73 310.966 1041.06C317.302 1047.4 320.862 1055.99 320.862 1064.95C320.862 1073.91 317.302 1082.51 310.966 1088.84C304.63 1095.18 296.037 1098.74 287.076 1098.74V1064.95Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M395.473 1064.95L427.62 1075.4C426.248 1079.63 424.058 1083.54 421.174 1086.91C418.291 1090.29 414.771 1093.06 410.815 1095.08C406.86 1097.09 402.546 1098.31 398.121 1098.65C393.695 1099 389.245 1098.47 385.023 1097.1C380.801 1095.73 376.891 1093.54 373.516 1090.66C370.141 1087.77 367.367 1084.25 365.352 1080.3C363.337 1076.34 362.121 1072.03 361.774 1067.6C361.426 1063.18 361.953 1058.73 363.326 1054.5C365.46 1047.67 369.741 1041.71 375.532 1037.51C381.324 1033.3 388.317 1031.08 395.473 1031.17V1064.95Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M395.473 1064.95V1031.17C399.913 1031.16 404.311 1032.03 408.415 1033.73C412.52 1035.42 416.249 1037.91 419.391 1041.05C422.533 1044.19 425.026 1047.91 426.727 1052.01C428.427 1056.12 429.303 1060.51 429.303 1064.95C429.321 1068.51 428.752 1072.04 427.62 1075.4L395.473 1064.95Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M612.446 1064.95L644.593 1075.4C643.221 1079.63 641.03 1083.54 638.147 1086.91C635.263 1090.29 631.744 1093.06 627.788 1095.08C623.832 1097.09 619.519 1098.31 615.093 1098.65C610.668 1099 606.217 1098.47 601.996 1097.1C597.774 1095.73 593.864 1093.54 590.489 1090.66C587.114 1087.77 584.34 1084.25 582.325 1080.3C580.31 1076.34 579.094 1072.03 578.746 1067.6C578.399 1063.18 578.926 1058.73 580.298 1054.5C582.433 1047.67 586.713 1041.71 592.505 1037.51C598.296 1033.3 605.29 1031.08 612.446 1031.17V1064.95Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M612.445 1064.95V1031.17C616.884 1031.16 621.28 1032.03 625.381 1033.73C629.483 1035.42 633.21 1037.91 636.348 1041.05C639.487 1044.19 641.975 1047.92 643.671 1052.02C645.367 1056.12 646.237 1060.52 646.231 1064.95C646.264 1068.5 645.71 1072.03 644.593 1075.4L612.445 1064.95Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M619.087 1371.68H589.508V1381.69H619.087V1371.68Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M586.231 1321.69H556.652V1381.69H586.231V1321.69Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M553.419 1343.25H523.84V1381.73H553.419V1343.25Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M520.563 1313.23H490.984V1381.69H520.563V1313.23Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M487.708 1364.02H458.129V1381.73H487.708V1364.02Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M454.853 1358.62H425.273V1381.69H454.853V1358.62Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M421.997 1335.55H392.418V1381.73H421.997V1335.55Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M389.142 1374.03H359.562V1381.73H389.142V1374.03Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M356.284 1321.69H326.705V1381.69H356.284V1321.69Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M323.429 1333.25H293.85V1381.73H323.429V1333.25Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M290.618 1379.39H261.039V1381.69H290.618V1379.39Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M257.763 1378.63H228.184V1381.69H257.763V1378.63Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M224.907 1343.25H195.328V1381.73H224.907V1343.25Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M192.05 1374.03H162.471V1381.73H192.05V1374.03Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M159.194 1366.32H129.615V1381.73H159.194V1366.32Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1418.12 633.534H836.414C815.505 633.534 798.555 650.484 798.555 671.394V1091.17C798.555 1112.08 815.505 1129.03 836.414 1129.03H1418.12C1439.03 1129.03 1455.98 1112.08 1455.98 1091.17V671.394C1455.98 650.484 1439.03 633.534 1418.12 633.534Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1395.32 607.497H813.609C792.7 607.497 775.75 624.447 775.75 645.356V1065.13C775.75 1086.04 792.7 1102.99 813.609 1102.99H1395.32C1416.22 1102.99 1433.18 1086.04 1433.18 1065.13V645.356C1433.18 624.447 1416.22 607.497 1395.32 607.497Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.77 995.169H1357.68V1032.98H1391.77V995.169Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.87 806.093H1319.77V1032.94H1353.87V806.093Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.96 887.568H1281.87V1032.98H1315.96V887.568Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.11 774.123H1244.01V1032.98H1278.11V774.123Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.2 966.077H1206.11V1032.98H1240.2V966.077Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.3 945.708H1168.2V1032.94H1202.3V945.708Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.44 858.477H1130.34V1032.98H1164.44V858.477Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.54 1003.89H1092.44V1032.98H1126.54V1003.89Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.63 806.093H1054.54V1032.94H1088.63V806.093Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.77 849.753H1016.68V1032.98H1050.77V849.753Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.87 1024.22H978.773V1032.94H1012.87V1024.22Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M974.965 1021.34H940.869V1032.98H974.965V1021.34Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M937.062 887.568H902.967V1032.98H937.062V887.568Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M899.203 1003.89H865.107V1032.98H899.203V1003.89Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M861.299 974.8H827.203V1032.98H861.299V974.8Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.99 711.023H831.631V739.805H1393.99V711.023Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1071.01 713.105H979.791V737.681H1071.01V713.105Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1246 713.105H1074.68V737.681H1246V713.105Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1346.39 98.2334H890.125C869.216 98.2334 852.266 115.184 852.266 136.093V461.329C852.266 482.239 869.216 499.189 890.125 499.189H1346.39C1367.3 499.189 1384.25 482.239 1384.25 461.329V136.093C1384.25 115.184 1367.3 98.2334 1346.39 98.2334Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1326.81 72.1963H870.553C849.644 72.1963 832.693 89.1465 832.693 110.056V435.292C832.693 456.201 849.644 473.152 870.553 473.152H1326.81C1347.72 473.152 1364.67 456.201 1364.67 435.292V110.056C1364.67 89.1465 1347.72 72.1963 1326.81 72.1963Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M857.402 435.603H1356.88",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M857.402 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M890.701 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M923.998 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M957.297 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M990.596 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.89 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.19 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.49 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.79 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.09 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.39 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.69 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.98 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.28 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.58 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.88 435.603V442.997",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M874.051 429.58H1340.23V365.153L1307.24 301.39C1307.03 300.941 1306.88 300.464 1306.8 299.973L1277.49 110.853C1277.49 109.913 1277.11 109.012 1276.45 108.348C1275.78 107.684 1274.88 107.311 1273.94 107.311C1273 107.311 1272.1 107.684 1271.44 108.348C1270.77 109.012 1270.4 109.913 1270.4 110.853L1240.56 341.729C1240.42 342.835 1239.86 343.847 1239.01 344.563L1210.27 366.703C1209.85 367.011 1209.37 367.219 1208.87 367.312C1208.36 367.405 1207.84 367.38 1207.34 367.239C1206.84 367.098 1206.39 366.844 1206 366.498C1205.62 366.151 1205.32 365.722 1205.13 365.242L1176.17 305.508C1175.96 304.947 1175.6 304.455 1175.13 304.084C1174.66 303.712 1174.09 303.475 1173.5 303.398C1172.9 303.321 1172.3 303.406 1171.75 303.645C1171.2 303.884 1170.72 304.268 1170.37 304.755L1140.44 343.5L1107.14 386.452L1073.84 343.5L1044.48 305.641C1044.1 305.112 1043.57 304.706 1042.96 304.474C1042.34 304.243 1041.68 304.194 1041.04 304.335C1040.4 304.476 1039.82 304.8 1039.36 305.268C1038.9 305.736 1038.59 306.327 1038.46 306.969L1007.47 403.632L974.168 231.339L940.869 420.813L907.571 395.042L881.003 320.209C879.497 315.781 874.095 317.198 874.095 321.803L874.051 429.58Z",
    fill: "#BA68C8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.23 429.713H874.051V374.496L906.995 319.677C907.226 319.299 907.377 318.877 907.438 318.438L936.751 155.797C936.912 154.969 937.355 154.223 938.006 153.687C938.656 153.151 939.473 152.857 940.316 152.857C941.159 152.857 941.976 153.151 942.626 153.687C943.276 154.223 943.72 154.969 943.88 155.797L973.681 354.349C973.869 355.339 974.442 356.215 975.275 356.784L1004.01 375.913C1004.43 376.19 1004.89 376.378 1005.38 376.466C1005.87 376.553 1006.37 376.538 1006.85 376.422C1007.34 376.305 1007.79 376.089 1008.18 375.788C1008.58 375.487 1008.91 375.108 1009.15 374.673L1038.06 323.308C1038.34 322.812 1038.74 322.389 1039.22 322.076C1039.69 321.763 1040.24 321.568 1040.8 321.507C1041.37 321.447 1041.95 321.522 1042.48 321.728C1043.01 321.933 1043.49 322.262 1043.86 322.688L1073.84 355.898L1107.14 392.828L1140.44 355.898L1169.75 323.353C1170.17 322.897 1170.7 322.555 1171.28 322.36C1171.87 322.165 1172.5 322.123 1173.11 322.239C1173.71 322.354 1174.28 322.622 1174.76 323.019C1175.23 323.415 1175.6 323.927 1175.82 324.504L1206.82 407.617H1240.11L1273.41 422.407L1306.71 400.267L1333.28 335.928C1333.57 335.126 1334.14 334.454 1334.89 334.035C1335.63 333.616 1336.5 333.477 1337.34 333.643C1338.18 333.808 1338.93 334.268 1339.46 334.938C1339.99 335.609 1340.26 336.447 1340.23 337.301V429.713Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.49 125.643H1229.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.49 149.819H1229.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.49 173.952H1229.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.49 198.129H1229.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.49 222.261H1229.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.49 246.438H1229.66",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.02 125.643H1115.95",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.02 149.819H1115.95",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.02 173.952H1115.95",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.02 198.129H1115.95",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.02 222.261H1115.95",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.02 246.438H1115.95",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M720.931 1773.74C866.292 1773.74 984.131 1715.26 984.131 1643.12C984.131 1570.98 866.292 1512.49 720.931 1512.49C575.569 1512.49 457.73 1570.98 457.73 1643.12C457.73 1715.26 575.569 1773.74 720.931 1773.74Z",
    fill: "#BA68C8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M720.931 1773.74C866.292 1773.74 984.131 1715.26 984.131 1643.12C984.131 1570.98 866.292 1512.49 720.931 1512.49C575.569 1512.49 457.73 1570.98 457.73 1643.12C457.73 1715.26 575.569 1773.74 720.931 1773.74Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M632.503 658.419C632.503 658.419 564.932 899.435 564.932 917.988C564.932 933.796 587.072 965.368 611.514 952.704C635.957 940.04 641.492 900.631 641.492 900.631L632.503 658.419Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M813.255 1645.69C813.255 1645.69 778.672 1692.4 776.059 1712.11C773.447 1731.81 800.192 1733.36 811.97 1724.19C823.749 1715.03 848.28 1655.25 848.28 1655.25L813.255 1645.69Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M624.532 1533.21C624.532 1533.21 565.33 1558.1 565.33 1572.31C565.33 1586.53 596.105 1582.94 618.466 1574.66C640.827 1566.38 676.473 1552.17 676.473 1552.17C676.473 1552.17 642.289 1529.67 624.532 1533.21Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M643.086 970.858L641.093 1047.82C641.093 1047.82 625.728 1188.72 618.599 1264.52C611.47 1340.33 634.008 1514.35 634.008 1514.35L623.337 1524.98V1535.65L676.473 1552.21C678.841 1541.28 680.425 1530.2 681.211 1519.04V1501.33L736.871 1168.66C736.871 1168.66 780.664 1504.92 787.793 1543.97C794.922 1583.03 805.505 1624.48 805.505 1624.48L801.962 1636.3L806.656 1657.64L843.364 1667.12C849.568 1657.53 853.24 1646.53 854.036 1635.15C856.382 1613.8 857.578 1564.08 857.578 1564.08C857.578 1564.08 855.231 1391.39 863.512 1274.04C868.442 1201.87 867.642 1129.43 861.12 1057.38L855.231 979.272C785.981 1003.29 710.216 1000.29 643.086 970.858Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M737.005 1168.57L731.071 1124.78L707.426 1099.93",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M819.897 1013.5C819.897 1013.5 803.292 1044.27 848.281 1058.49",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M848.279 1072.7V1619.65",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M699.1 1020.58L703.838 1049.01C703.838 1049.01 692.015 1070.31 696.753 1079.79",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M722.835 627.689C722.835 627.689 634.054 653.682 632.504 658.42C630.954 663.157 643.087 970.859 643.087 970.859C643.087 970.859 666.777 1007.17 731.647 1012.7C796.517 1018.24 857.933 984.276 857.933 984.276L900.265 704.117C900.265 704.117 798.421 634.641 791.336 633.047C784.252 631.453 742.584 622.154 722.835 627.689Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M716.725 686.847L737.802 738.566L773.846 697.74C773.846 697.74 771.145 671.88 747.278 669.179C740.929 668.151 734.42 669.348 728.852 672.567C723.284 675.787 719 680.831 716.725 686.847Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M722.835 627.689L685.418 686.847C685.418 686.847 707.204 681.4 717.388 690.256C727.573 699.112 739.174 708.633 739.174 708.633C739.174 708.633 756.886 694.33 771.144 699.112C780.908 702.705 790.074 707.751 798.332 714.079C798.332 714.079 807.188 655.585 795.631 629.061C784.074 602.538 747.321 592.973 722.835 627.689Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M732.355 634.464C731.217 651.68 730.995 668.944 731.691 686.183C733.019 707.969 739.839 712.751 747.986 698.449C756.134 684.146 774.554 640.619 774.554 628.353C774.582 620.63 775.025 612.915 775.882 605.239C775.882 605.239 747.322 635.748 732.355 634.464Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M737.802 738.566L702.422 918.83L726.244 978.697L755.514 929.723L737.802 738.566Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M807.277 902.977C807.277 902.977 727.573 854.845 720.488 848.557C713.403 842.269 713.359 846.963 707.824 850.107C702.289 853.251 681.787 877.738 677.846 885.531C673.905 893.324 667.573 904.483 675.5 906.077C683.426 907.671 689.713 892.793 689.713 890.269C689.713 887.745 701.536 874.505 701.536 874.505C701.536 874.505 689.713 902.889 693.654 905.28C697.595 907.671 724.429 918.564 729.964 918.564C735.499 918.564 739.396 908.291 739.396 908.291C739.396 908.291 747.322 918.564 755.204 917.767C759.94 917.243 764.489 915.621 768.487 913.029L795.321 934.327L807.277 902.977Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M807.276 902.978C807.276 902.978 797.357 897 784.25 888.985L772.561 916.395L795.453 934.55L807.276 902.978Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M703.838 910.904C703.838 910.904 706.229 885.62 716.502 871.406",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M717.256 914.048C717.256 914.048 722.791 891.908 733.861 879.332",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M867.232 718.33C848.298 735.071 835.282 757.484 830.126 782.226L879.852 923.568C879.852 923.568 820.65 899.081 813.432 898.328C806.215 897.575 781.064 932.246 788.193 940.128C795.322 948.01 934.317 1026.16 942.863 1015.89C951.409 1005.62 907.439 726.256 902.612 715.983C897.786 705.71 901.062 700.219 884.457 697.828",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M867.232 718.33C848.298 735.071 835.282 757.484 830.126 782.226L879.852 923.568C879.852 923.568 820.65 899.081 813.432 898.328C806.215 897.575 781.064 932.246 788.193 940.128C795.322 948.01 934.317 1026.16 942.863 1015.89C951.409 1005.62 907.439 726.256 902.612 715.983C897.786 705.71 901.062 700.219 884.457 697.828",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M879.852 923.567C879.852 923.567 908.279 929.899 916.161 944.866L879.852 923.567Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M879.852 923.567C879.852 923.567 908.279 929.899 916.161 944.866",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M562.099 807.156L625.508 948.851C626.167 950.258 627.316 951.376 628.74 951.995L719.47 989.191C720.555 989.656 721.752 989.794 722.915 989.589C724.078 989.384 725.155 988.844 726.015 988.035C726.875 987.227 727.481 986.185 727.758 985.037C728.035 983.89 727.971 982.686 727.573 981.574L676.784 844.306C675.893 841.898 674.49 839.712 672.67 837.899C670.85 836.087 668.658 834.693 666.246 833.812L569.804 798.875C568.668 798.422 567.421 798.324 566.228 798.592C565.035 798.86 563.951 799.483 563.117 800.378C562.284 801.274 561.741 802.4 561.56 803.609C561.378 804.819 561.566 806.055 562.099 807.156Z",
    fill: "#BA68C8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M585.878 882.697C584.991 882.514 584.074 882.541 583.2 882.775C582.325 883.01 581.518 883.446 580.842 884.048C580.167 884.651 579.642 885.403 579.309 886.245C578.976 887.087 578.845 887.995 578.926 888.896C578.905 890.94 579.684 892.91 581.095 894.387C584.593 896.867 610.852 898.815 609.833 893.856C609.169 890.003 595.619 884.601 585.878 882.697Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M577.684 873.133C576.631 872.916 575.542 872.947 574.503 873.224C573.465 873.502 572.505 874.018 571.701 874.732C570.897 875.446 570.27 876.337 569.872 877.336C569.473 878.334 569.313 879.412 569.404 880.484C569.382 882.913 570.321 885.252 572.016 886.993C576.134 889.915 607.44 892.262 606.112 886.373C605.182 881.812 589.108 875.391 577.684 873.133Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M575.205 859.051C574.069 858.844 572.901 858.9 571.79 859.217C570.68 859.533 569.657 860.1 568.801 860.875C567.945 861.65 567.278 862.611 566.853 863.685C566.428 864.758 566.255 865.915 566.349 867.066C566.33 869.707 567.348 872.251 569.183 874.151C573.611 877.339 607.529 879.907 606.245 873.531C605.138 868.527 587.648 861.575 575.205 859.051Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M570.113 845.635C568.977 845.428 567.809 845.484 566.698 845.801C565.588 846.117 564.565 846.684 563.709 847.459C562.853 848.234 562.186 849.195 561.761 850.269C561.336 851.342 561.164 852.499 561.257 853.65C561.226 854.961 561.461 856.265 561.948 857.483C562.435 858.701 563.164 859.807 564.091 860.735C568.519 863.923 602.438 866.491 601.153 860.115C600.002 855.111 582.556 848.292 570.113 845.635Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M689.182 532.132C689.182 532.132 694.495 586.331 706.362 611.438C718.229 636.545 722.214 648.412 734.126 648.412C746.037 648.412 768.487 631.231 779.026 615.379C784.307 607.721 789.171 599.784 793.594 591.6L796.206 585.003C796.206 585.003 814.715 571.719 818.701 562.553C822.686 553.387 814.715 546.701 800.192 554.627C800.192 554.627 805.461 513.668 794.878 488.561C784.295 463.454 703.75 487.233 689.182 532.132Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M674.791 552.723L764.059 570.922C764.059 570.922 764.679 584.781 755.204 589.165C750.547 591.159 745.424 591.801 740.42 591.018C735.415 590.235 730.733 588.058 726.909 584.737C720.001 578.449 720.001 566.494 720.001 566.494C720.001 566.494 714.333 562.066 713.713 566.494C713.076 570.618 710.948 574.366 707.733 577.026C704.517 579.687 700.438 581.075 696.267 580.929C692.101 580.726 688.091 579.286 684.747 576.794C681.403 574.302 678.877 570.87 677.492 566.937C675.952 562.343 675.043 557.561 674.791 552.723Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M764.059 570.922L801.165 551.438",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M674.791 552.723L689.226 547.055",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M714.378 570.302L708.09 593.593L715.662 595.453L717.521 613.696L729.477 610.552",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M714.378 570.302L708.09 593.593L715.662 595.453L717.521 613.696L729.477 610.552",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M727.573 444.945C727.573 444.945 674.702 485.904 669.433 511.011C664.164 536.118 698.481 546.701 720.975 542.715C743.469 538.73 776.281 517.609 776.281 517.609C776.281 517.609 757.772 546.701 772.295 547.985C778.874 548.934 785.554 548.934 792.133 547.985C792.133 547.985 784.207 563.881 790.804 563.881C797.402 563.881 800.059 554.627 800.059 554.627C800.059 554.627 818.568 511.011 813.343 471.38C808.118 431.75 759.233 419.838 727.573 444.945Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientfinancial);
export default __webpack_public_path__ + "static/media/patient financial.3defba6cd5a0da861f7d7c4b21f2de7e.svg";
export { ForwardRef as ReactComponent };